
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ThresholdPageComponent} from './components/threshold.settings/kpi-threshold-tab/threshold.page.component';
import {CommonMaterialModule} from "@nrwl/common-material";
import { ThresholdEditDetailsComponent } from './components/threshold.settings/kpi-threshold-tab/threshold.edit.details/threshold.edit.details.component';
import {ThresholdWidgetComponent} from './components/threshold.settings/kpi-threshold-tab/threshold.widget/threshold.widget.component';
import {RouterModule, RouteReuseStrategy} from '@angular/router';
import { CommonLibModule } from "@nrwl/common-lib";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import { ViewTableModule } from '@nrwl/view-table';
import { MachineLearningTabComponent } from './components/threshold.settings/machine-learning-tab/machine-learning-tab.component';
import { ThresholdSettingsComponent } from './components/threshold.settings/threshold.settings.component';
import { ThresholdEditSubcontentDetailsComponent } from './components/threshold.settings/kpi-threshold-tab/threshold.edit.details/threshold.edit.subcontent.details/threshold.edit.subcontent.details.component';

@NgModule({
  imports: [
    CommonModule,
    CommonMaterialModule,
    RouterModule,
    CommonLibModule,
    FormsModule,
    ReactiveFormsModule,
    ViewTableModule
  ],
  declarations: [ThresholdPageComponent, ThresholdEditDetailsComponent,ThresholdWidgetComponent, MachineLearningTabComponent, ThresholdSettingsComponent, ThresholdEditSubcontentDetailsComponent],
  exports: [ThresholdPageComponent,ThresholdWidgetComponent]
})
export class ThresholdSettingsModule { }
